<app-loading *ngIf="loading"></app-loading>
<ng-container *ngIf="!loading">
  <app-header></app-header>
  <div class="site-wrapper grey-bg page-body">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
  <app-cookie-message></app-cookie-message>
</ng-container>
